const getPathname = (url: string) => url.split('?')[0].split('#')[0];

export const isProductDetailPath = (url: string) => {
	return /^\/(?:(?:en|de|it)\/)?product\/[^/]+\/?$/.test(getPathname(url));
};
